import * as React from 'react'

import { Card } from '@grandvisionhq/common'
import { SummarySlotType } from '@grandvisionhq/lib-form-slots'
import { useIntl } from '@grandvisionhq/state'

import { isValidBirthDate } from '../../data-utils/is-valid-birth-date'

type Props = {
  email: string
  type?: string
  className?: string
}

export const PersonalDetailsSummary: SummarySlotType<Props> = ({
  className,
  actions,
  values = {},
  email,
}) => {
  const DOB = values.dateOfBirth
  const hasValidDOB = DOB && isValidBirthDate(DOB)
  const { getLabel } = useIntl()

  return (
    <Card className={className}>
      <Card.Content>
        {actions?.onEdit && (
          <Card.Actions>
            <Card.Button onClick={actions.onEdit} children={getLabel('common.actions.edit')} />
          </Card.Actions>
        )}
        <Card.Text>
          {values.firstName}, {values.lastName}
        </Card.Text>
        <Card.Text>{values.phone}</Card.Text>
        <Card.Text>{email}</Card.Text>
        {hasValidDOB ? <Card.Text>{Intl.DateTimeFormat().format(new Date(DOB))}</Card.Text> : null}
      </Card.Content>
    </Card>
  )
}
